import React, { useEffect, useState } from "react";
import { useSearch } from "../Hooks/index";
import { Helmet } from "react-helmet";
import Search from "../Components/Search";
import Sort from "../Components/Sort";
import Filter from "../Components/Filter";
import FlatList from "../Components/FlatList";
import Mobile2 from "../../../Common/Mobile2";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

function Index() {
  const [filterDialog, setFilterDialog] = useState(false);

  const toggleFilterDialog = status => {
    setFilterDialog(status);
  };

  const {
    search,
    handleFilter,
    searchHandler,
    state,
    loading,
    getValue,
    clearFilters,
    filterDelete,
  } = useSearch();
  const btnHandler = () => {
    searchHandler({ ...search });
  };
  useEffect(() => {
    searchHandler({ ...search });
  }, []);

  return (
    <>
      <Helmet>
        <title>نیکوتن | کلاس های ورزشی </title>
        <meta name="description" content={"کلاس های ورزشی"} />
        <link rel="canonical" href={window.origin + `/Classes/List`} />
      </Helmet>
      <div
        id="list-class-page"
        style={{
          backgroundColor: "#F6F6F6",
          position: "relative",
        }}
      >
        <Search
          handleFilter={handleFilter}
          getValue={getValue}
          btnHandler={btnHandler}
          loading={loading}
          filterDelete={filterDelete}
        />
        <div className="container">
          <div className="row">
            <div className="col-3 d-none d-xl-block">
              <Filter
                handleFilter={handleFilter}
                getValue={getValue}
                clearFilters={clearFilters}
                search={search}
                filterDelete={filterDelete}
              />
            </div>
            <div className="col-12 col-xl-9">
              <Sort
                loading={loading}
                count={state.total}
                handleFilter={handleFilter}
                getValue={getValue}
                toggleFilterDialog={toggleFilterDialog}
              />
              <FlatList
                loading={loading}
                data={state}
                handleFilter={handleFilter}
                getValue={getValue}
                searchHandler={searchHandler}
                search={search}
              />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Mobile2 />
            </div>
          </div>
        </div>
      </div>

      <Dialog
        // fullScreen
        scroll="paper"
        open={filterDialog}
        onClose={() => toggleFilterDialog(false)}
      >
        <DialogTitle id="scroll-dialog-title" style={{ width: "80vw" }}>
          <div className="">
            <CloseIcon onClick={() => toggleFilterDialog(false)} />
            <span className="h6 mx-3">فیلتر ها</span>
          </div>
        </DialogTitle>

        <DialogContent dividers>
          <Filter
            handleFilter={handleFilter}
            getValue={getValue}
            clearFilters={clearFilters}
            search={search}
            filterDelete={filterDelete}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Index;
